import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { BlobResponse } from '../../Models/OtherClasses';
@Injectable()
export class DeliveryZoneService {
  private url: string;

  constructor(
    private myBaseService: BaseService,
    private urlService: UrlService
  ) {
    this.url = urlService.getURL('DeliveryZone');
  }


	downloadRates(): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/DownloadRates');
	}

  loadAll(): Observable<TooBig4Car.Logic.DeliveryZone[]> {
    return this.myBaseService.loadAll(this.url);
  }
  loadAllForDeliveryZoneGroup(id: System.Guid): Observable<TooBig4Car.Logic.DeliveryZone[]> {
    return this.myBaseService.loadAll(this.url + '/ForGroup/' + (id || ''));
  }

  save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.DeliveryZone> {
    return this.myBaseService.save(tempItem, this.url);
  }
  deleteItem(id: System.Guid): Observable<boolean> {
    return this.myBaseService.deleteItem(id, this.url);
  }
  getEdit(id: System.Guid): Observable<TooBig4Car.Logic.DeliveryZone> {
    return this.myBaseService.getEdit(id, this.url);
  }
  get(id: System.Guid): Observable<TooBig4Car.Logic.DeliveryZone> {
    return this.myBaseService.get(id, this.url);
  }
  search(searchTerm: string): Observable<TooBig4Car.Logic.DeliveryZone[]> {
    return this.myBaseService.post(searchTerm, this.url + '/Search', false);
  }
}

